<template>
  <div class="con10">
    <div class="container">
      <div class="top">
        <div>
          <img src="@/assets/img/aitutorplus/con10/icon.png" alt="" />
          <p>지금 바로 시작하세요!</p>
          <p>모바일폰으로 QR코드를 스캔해<br />AI튜터 Plus를 만나보세요.</p>
        </div>
        <img src="@/assets/img/aitutorplus/con10/qr.png" alt="" />
      </div>
    </div>
    <div class="line"></div>
    <div class="container">
      <div class="bottom">
        <ul class="content-top">
          <li>
            <span @click="goPage('/PrivacyPolicy')">개인정보처리방침</span> •
            <span @click="goPage('/TermsOfUse')">이용약관</span>
          </li>
          <li class="content-top-line">&nbsp;│&nbsp;</li>
          <li>
            <span
              @click="
                goSite('https://www.ftc.go.kr/bizCommPop.do?wrkr_no=3578702040')
              "
              >사업자등록번호확인</span
            >
          </li>
          <li class="content-top-line">&nbsp;│&nbsp;</li>
          <li>
            <span @click="goSite('https://www.instagram.com/carrot_aitutor/')"
              >인스타그램</span
            >
          </li>
        </ul>
        <div class="content-middle">
          <div>
            <p>AI튜터 Plus │ ㈜캐럿솔루션즈</p>
            <p>
              서울특별시 서초구 강남대로 479 신논현타워 6F 06541<br
                class="br-m"
              /><span class="span-pc"> │ </span>사업자등록번호 357-87-02040
            </p>
            <p>
              대표이사 : 이은경<br class="br-m" /><span class="span-pc">
                │ </span
              >통신판매업 신고번호 : 2021-서울강남-05834<br class="br-m" /><span
                class="span-pc"
              >
                │ </span
              >대표번호 : 02-518-2603
            </p>
            <p>
              이메일 : aitutor@carrotglobal.com<br class="br-m" /><span
                class="span-pc"
              >
                │ </span
              >호스팅제공자 : Naver Cloud<br class="br-m" /><span
                class="span-pc"
              >
                │ </span
              >개인정보관리책임자 : 김범진
            </p>
          </div>
          <p>
            Contact │ AI튜터 Plus팀<br class="br-m" /><span class="span-pc">
              : </span
            >aitutor@carrotglobal.com
          </p>
        </div>
        <p class="copyright">ⓒCARROT Solutions Inc. All rights reserved.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goPage(path) {
      this.$router.push(path, () => {
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      });
    },
    goSite(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.span-pc {
  display: none;
  @media screen and (min-width: 1200px) {
    display: inline;
  }
}

.con10 {
  padding: 66px 0 100px;
  background-color: #18181b;

  @media screen and (min-width: 1200px) {
    padding: 138px 0 88px;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    max-width: 1000px;
    margin: 0 auto;

    @media screen and (min-width: 1200px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 26px;

      @media screen and (min-width: 1200px) {
        align-items: flex-start;
        gap: 0;
      }

      img {
        width: 56px;
        transform: rotate(90deg);

        @media screen and (min-width: 1200px) {
          transform: rotate(0deg);
          margin-bottom: 16px;
        }
      }

      p {
        font-weight: 700;

        &:nth-of-type(1) {
          font-size: 30px;
          color: #fff;

          @media screen and (min-width: 1200px) {
            font-size: 52px;
            margin-bottom: 56px;
          }
        }

        &:nth-of-type(2) {
          font-size: 20px;
          color: #b6bac3;
          text-align: center;
          line-height: 30px;

          @media screen and (min-width: 1200px) {
            font-size: 28px;
            text-align: left;
            line-height: 40px;
          }
        }
      }
    }

    > img {
      width: 142px;

      @media screen and (min-width: 1200px) {
        width: 208px;
        padding-top: 54px;
      }
    }
  }

  .line {
    height: 1px;
    background-color: #374151;
    margin: 81px 0 44px;

    @media screen and (min-width: 1200px) {
      margin: 138px 0 54px;
    }
  }

  .bottom {
    max-width: 1000px;
    margin: 0 auto;

    .content-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 15px;
      color: #b6bac3;
      margin-bottom: 24px;

      span {
        cursor: pointer;
      }

      @media screen and (min-width: 1200px) {
        font-size: 17px;
        margin-bottom: 30px;
      }

      .content-top-line {
        color: #6b7280;
      }
    }

    .content-middle {
      display: flex;
      flex-direction: column;
      gap: 28px;
      font-size: 14px;
      color: #6b7280;
      line-height: 24px;

      @media screen and (min-width: 1200px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        font-size: 15px;
        line-height: 26px;
      }
    }

    .copyright {
      font-size: 14px;
      color: #6b7280;
      margin-top: 28px;

      @media screen and (min-width: 1200px) {
        font-size: 15px;
        margin-top: 32px;
      }
    }
  }
}
</style>
